import HTTP from '../HTTP';

const URL_BASE = 'commun/PieceJointe/';

export async function getAll() {
  const response = await HTTP.get(URL_BASE + 'GetAllAsync');
  return response;
}

export async function getAllByElementId(elementId) {
  const response = await HTTP.get(URL_BASE + 'GetAllByElementId/?ElementId=' + elementId);
  return response;
}
export async function getConfiguration() {
  const response = await HTTP.get(URL_BASE + 'GetConfiguration');
  return response;
}

export async function pGetAllPieceJointe(informationsPieceJointe) {
  const response = await HTTP.post(URL_BASE + 'PGetAllByElementsIdAsync', informationsPieceJointe);
  return response;
}

export async function createPiecesJointes(fd) {
  const response = await HTTP.post(URL_BASE + 'CreatePiecesJointes', fd);
  return response;
}
export async function updatePiecesJointes(fd) {
  const response = await HTTP.put(URL_BASE + 'UpdatePiecesJointes', fd);
  return response;
}

export async function remove(idPieceJointe) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', { params: { id: idPieceJointe } });
  return response;
}

export async function copiePieceJointe(params) {
  const response = await HTTP.post(URL_BASE + 'CopiePJAsync', params);
  return response;
}
